'use client';

import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ColorFacetViewModel } from '@/types/api';
import Variant from '../pdp-components/color-variant';
interface Props {
  items: ColorFacetViewModel[];
  defaultSelectedItems?: string[];
  onClickColor: (selectedItems: string[]) => void;
}
export function Colors({
  items,
  defaultSelectedItems,
  onClickColor
}: Props) {
  const [selectedColors, setSelectedColors] = useState<string[]>(defaultSelectedItems || []);
  const onClick = (id: string) => {
    const updatedLocalState = selectedColors.includes(id) ? selectedColors.filter(item => item !== id) : [...selectedColors, id];
    setSelectedColors(updatedLocalState);
    onClickColor(updatedLocalState);
  };
  useEffect(() => {
    if (!items) return;
    const newSelectedItems: string[] = items.filter(item => typeof item.key === 'string' && item.key && item.isSelected).map(item => item.key as string);
    setSelectedColors(newSelectedItems);
  }, [items]);
  return <div className='grid grid-cols-2 gap-1 lg:grid-cols-3 lg:gap-y-4 lg:px-4 lg:py-2' data-sentry-component="Colors" data-sentry-source-file="colors.tsx">
            {items?.map(({
      key,
      displayNameFa,
      displayNameEn,
      imageUrl,
      count
    }) => {
      const id = key || 'unknown-id';
      const name = displayNameFa || displayNameEn || '';
      const isActive = selectedColors?.includes(id);
      return <div key={id} role='button' className='group flex cursor-pointer items-center gap-0.5 px-2 py-1.5 lg:flex-col lg:px-0 lg:py-0' onClick={() => onClick(id)}>
                        <Variant color={{
          id,
          name,
          image: imageUrl || ''
        }} selectedVariantId={isActive ? id : undefined} />
                        <span className={classNames('text-xs font-medium text-gray-500 group-hover:text-gray-900', {
          'font-bold text-gray-900': isActive
        })}>
                            {name}
                            <span className='mr-0.5 text-text-mediumGray lg:hidden'>({count})</span>
                        </span>
                    </div>;
    })}
        </div>;
}